import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Evidencias from '../views/Evidencias.vue';

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/evidencias', name: 'evidencias', component: Evidencias }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
